import Page from './LessonThumbPage';

export default Page;
